/**
 * 滑动菜单组件
 * 提供可左右滑动的横向菜单导航功能
 * 
 * @module common/components/SlideMenu
 * @author wei<innereyecw@gmail.com>
 * @version 5.0.0
 */
(function (global) {
  "use strict";

  // 确保命名空间存在
  if (!global.watashi) {
    global.watashi = {};
  }
  if (!global.watashi.common) {
    global.watashi.common = {};
  }

  const common = global.watashi.common;
  const logger = (global.watashi.core && global.watashi.core.logger) || console;

  /**
   * 滑动菜单组件
   * @class SlideMenu
   * 
   * @example
   * new watashi.common.SlideMenu({
   *   container: '#newest_menu .menu-container',
   *   menuSelector: '#newest_menu .menu-container a',
   *   selectedSelector: '#newest_menu .menu-container a.hover',
   *   speed: 150,
   *   navigation: {
   *     prevEl: '#newest_menu .button.left',
   *     nextEl: '#newest_menu .button.right'
   *   }
   * });
   */
  common.SlideMenu = (function () {
    const defaults = {
      container: '',
      menuSelector: '',
      selectedSelector: '',
      speed: 300,
      navigation: {
        prevEl: '.slide-menu-prev',
        nextEl: '.slide-menu-next',
      },
    };

    /**
     * 创建滑动菜单实例
     * @param {Object} options - 配置选项
     */
    function SlideMenu(options) {
      this.settings = {...defaults, ...options};
      // 实例属性，避免多个实例共享状态
      this.menuContainer = null;
      this.menuItems = null;
      this.moveIndex = 0;
      this.menuWidth = 0;
      this.maxMove = 0;
      this.init();
    }

    const _slideMenu = SlideMenu.prototype;

    /**
     * 初始化菜单
     */
    _slideMenu.init = function () {
      this.menuContainer = document.querySelector(this.settings.container);
      this.menuItems = document.querySelectorAll(this.settings.menuSelector);

      if (this.menuContainer && this.menuItems.length) {
        this.menuWidth = this.menuItems[0].offsetWidth;
        this.maxMove = this.menuItems.length - Math.ceil(this.menuContainer.offsetWidth / this.menuWidth);
        this.menuContainer.style.transition = `transform ${this.settings.speed}ms ease`;

        const current = this.currentIndex();
        this.moveIndex = current;
        this.updatePosition(current);
        this.bindEvents();
      } else {
        logger.log(`SlideMenu init failed: ${this.settings.container}`, 'warn');
      }
    };

    /**
     * 获取当前选中菜单的索引
     * @returns {number} 索引值
     */
    _slideMenu.currentIndex = function () {
      const selected = document.querySelector(this.settings.selectedSelector);
      return selected ? Array.from(this.menuItems).indexOf(selected) : 0;
    };

    /**
     * 更新菜单位置
     * @param {number} [newIndex=0] - 新的索引位置
     */
    _slideMenu.updatePosition = function (newIndex = 0) {
      const index = Math.min(Math.max(newIndex, 0), this.maxMove);
      this.menuContainer.style.transform = `translate3d(${-index * this.menuWidth}px, 0, 0)`;
    };

    /**
     * 绑定事件
     */
    _slideMenu.bindEvents = function () {
      const prevEl = document.querySelector(this.settings.navigation.prevEl);
      const nextEl = document.querySelector(this.settings.navigation.nextEl);

      if (prevEl) {
        common.registerEvent(prevEl, 'click', function () {
          this.moveIndex = Math.max(this.moveIndex - 1, 0);
          this.updatePosition(this.moveIndex);
        }.bind(this));
      }

      if (nextEl) {
        common.registerEvent(nextEl, 'click', function () {
          this.moveIndex = Math.min(this.moveIndex + 1, this.maxMove);
          this.updatePosition(this.moveIndex);
        }.bind(this));
      }
    };

    return SlideMenu;
  })();

})(typeof window !== "undefined" ? window : this);
